var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 5,
    viewBox: "0 0 81 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 0V4.5H76M5 4.5H0.5V0",
    stroke: "#2B303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreFooter);
export default __webpack_public_path__ + "static/media/moreFooter.21c0e9b695a0cda7a7650033d185d414.svg";
export { ForwardRef as ReactComponent };